import React, { useContext, useEffect } from 'react';

import { media } from 'context';
import { Animate, Layout } from 'ds';
import { selectDashboardWidgetConfigs } from 'store/Dashboard/selectors';
import { useAppSelector } from 'store/hooks';

import Widget from './Widget';

const BASE_DELAY = 20;
const SLOT_DELAY = 30;

interface Props {}

let hasAnimated = false;

const Widgets: React.FC<Props> = () => {
  const widgetConfigs = useAppSelector(selectDashboardWidgetConfigs);
  const { isMobile } = useContext(media);

  useEffect(() => {
    setTimeout(() => {
      hasAnimated = true;
    }, 1000);
  }, []);

  if (!widgetConfigs || widgetConfigs.length === 0) return null;

  const slot1 = widgetConfigs[0];
  const slot2 = widgetConfigs[1];
  const slot3 = widgetConfigs[2];

  return (
    <Layout {...(isMobile ? { direction: 'column', gap: 12 } : { height: 168, gap: 8, flex: true, width: '100%' })}>
      <WidgetsContainer>
        {slot1.map((widgetConfig, index) => (
          <WidgetContainer delay={BASE_DELAY + index * SLOT_DELAY} key={widgetConfig.type + index}>
            <Widget widgetConfig={widgetConfig} variant={slot1.length === 1 ? 'full' : 'half'} />
          </WidgetContainer>
        ))}
      </WidgetsContainer>
      <WidgetsContainer>
        {slot2.map((widgetConfig, index) => (
          <WidgetContainer delay={BASE_DELAY + SLOT_DELAY * 2 + index * SLOT_DELAY} key={widgetConfig.type + index}>
            <Widget widgetConfig={widgetConfig} variant={slot2.length === 1 ? 'full' : 'half'} />
          </WidgetContainer>
        ))}
      </WidgetsContainer>
      <WidgetsContainer>
        {slot3.map((widgetConfig, index) => (
          <WidgetContainer delay={BASE_DELAY + SLOT_DELAY * 4 + index * SLOT_DELAY} key={widgetConfig.type + index}>
            <Widget widgetConfig={widgetConfig} variant={slot3.length === 1 ? 'full' : 'half'} />
          </WidgetContainer>
        ))}
      </WidgetsContainer>
    </Layout>
  );
};

function WidgetContainer({ children, delay }: { children: React.ReactNode; delay?: number }) {
  if (hasAnimated)
    return (
      <Layout minWidth={0} height="100%">
        {children}
      </Layout>
    );
  return (
    <Animate delay={delay} minWidth={0} height="100%">
      {children}
    </Animate>
  );
}

function WidgetsContainer({ children }: { children: React.ReactNode }) {
  const { isMobile } = useContext(media);
  return (
    <Layout
      {...(isMobile
        ? { height: 168, direction: 'column', gap: 12 }
        : { height: '100%', direction: 'column', gap: 8, equalWidth: true, minWidth: 0 })}
    >
      {children}
    </Layout>
  );
}

export default Widgets;
